export default __webpack_public_path__ + "static/media/your-stores.67932587.svg";